import { GlobalMenu } from '@components';
import { AssetContext } from '@pages/Asset/Asset.query';
import { useContext } from 'react';
import { Container } from './PhotosMenu.styles';

const PhotosMenu = () => {
  const { setShowAdd, setShow } = useContext(AssetContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Add Picture',
            iconName: 'camera',
            onClick: () => {
              setShowAdd(true);
            },
          },
          {
            label: 'Expand',
            iconName: 'maximize',
            onClick: () => {
              setShow(true);
            },
          },
        ]}
      />
    </Container>
  );
};

export { PhotosMenu };
